module.exports = __webpack_public_path__ + "img/redeem-success-icon.a2d23d66.png";